var React = require('react');

function IconTelephone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M7.167 21.57a341.186 341.186 0 0 0-2.792-4.125c-1.389-2.062-2.306-3.452-2.75-4.168-.639-1.03-1.07-1.897-1.292-2.6C.111 9.977 0 9.168 0 8.25c0-1.49.361-2.865 1.083-4.125A8.285 8.285 0 0 1 4 1.117 7.544 7.544 0 0 1 8 0c1.444 0 2.778.372 4 1.117a8.285 8.285 0 0 1 2.917 3.008A8.154 8.154 0 0 1 16 8.25c0 .917-.111 1.726-.333 2.428-.223.702-.653 1.568-1.292 2.6-.444.715-1.361 2.105-2.75 4.167L8.833 21.57c-.194.287-.472.43-.833.43s-.639-.143-.833-.43zM8 11.687c.917 0 1.701-.336 2.354-1.01.653-.672.98-1.482.98-2.427 0-.945-.327-1.755-.98-2.428S8.917 4.812 8 4.812s-1.701.337-2.354 1.01a3.363 3.363 0 0 0-.98 2.428c0 .945.327 1.755.98 2.428s1.437 1.01 2.354 1.01z"}));
}

IconTelephone.defaultProps = {"width":"16","height":"22","viewBox":"0 0 16 22"};

module.exports = IconTelephone;

IconTelephone.default = IconTelephone;
